export const ru = {
    'new-banner': 'Новое объявление'
};
